module.exports = __webpack_public_path__ + "media/images/landing/icon-team-ce25e9883b37f6b1d537c54014a94e7e.svg";